import { useState } from 'react'
import TextField from "@mui/material/TextField";
import {Autocomplete} from "@mui/material";
import {useSelector} from "react-redux";
import {State} from "../../reducer";
import Grid from "@mui/material/Grid";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {CollectionNode, Elib, Node} from "../../types";
import {
    attachMarqueEditorialeToElib,
    dettachMarqueEditorialeToElib,
    getMarqueEditorialForElib,
    getMarqueEditorialForElibSuccess
} from '../../action/elibAction'
import {MarqueCollectionSelection} from "./MarqueCollectionSelection";
import {Button} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useAppDispatch } from '../../store';

interface Props {
    elibs: Elib[]
}

export const MarqueElibSelection = (props: Props) => {
    const {elibs} = props;
    const collectionList = useSelector(({marqueEditorial}: State) => marqueEditorial.collections);

    const marqueForElib = useSelector(({elib}: State) => elib.marqueCollectionForElib);

    const [selectedElib, setSelectedElib] = useState<Elib | null>(null);
    const dispatch = useAppDispatch()

    let [selectedMarqueCollection, setSelectedMarque] = useState<Node | null>(null);
    let [selectedCollection, setSelectedColl] = useState<CollectionNode | null>(null);

    return (
        <>
            <Grid
                container style={{marginTop: 37}}
                direction="row"
            >
                <Autocomplete style={{width: 200}}
                              options={elibs}
                              getOptionLabel={(option) => option.label}
                              onChange={(event: any, newValue: Elib | null) => {
                                  if (newValue === null) {
                                      dispatch(getMarqueEditorialForElibSuccess([]))
                                  } else {
                                      dispatch(getMarqueEditorialForElib(newValue.id))
                                  }
                                  setSelectedElib(newValue)
                              }}
                              renderInput={(params) => <TextField {...params} label="Groupe" variant="outlined"/>}
                />

            </Grid>
            <Grid
                container style={{marginTop: 15}}
                direction="row"
            >

                {selectedElib &&
                <Grid size={12} sx={{ height: 400, overflowY: 'scroll' }}>
                    <Table style={{marginTop: 15}}>
                        <TableHead>
                            <TableRow>
                                <TableCell style={{width: 300}}>Marque éditoriale</TableCell>
                                <TableCell style={{width: 300}}>Collection</TableCell>
                                <TableCell align={"center"}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell colSpan={2}>

                                    <MarqueCollectionSelection marqueCollections={collectionList}
                                                               selectedMarqueCollection={selectedMarqueCollection!!}
                                                               setSelectedMarqueCollection={setSelectedMarque}
                                                               setSelectedCollection={setSelectedColl}
                                                               selectedCollection={selectedCollection!!}
                                    />
                                </TableCell>
                                <TableCell align={"center"}>
                                    {selectedMarqueCollection &&
                                    <Button
                                        onClick={() => {
                                            dispatch(attachMarqueEditorialeToElib({
                                                marqueId: selectedMarqueCollection!!.value,
                                                collectionId: selectedCollection?.value.split(".")[1],
                                                elibId: selectedElib!!.id
                                            }));
                                            setSelectedMarque(null)
                                            setSelectedColl(null)

                                        }
                                        }
                                        color="inherit"
                                    >
                                        Ajouter
                                    </Button>
                                    }
                                </TableCell>
                            </TableRow>
                            {marqueForElib && marqueForElib.map(x =>
                                <TableRow>

                                    <TableCell>
                                        {x.marqueLabel}
                                    </TableCell>
                                    <TableCell>
                                        {x.collectionLabel}
                                    </TableCell>


                                    <TableCell align={"center"}>
                                        <label htmlFor="icon-button-file">
                                            <DeleteIcon className="icon"
                                                        onClick={() => dispatch(dettachMarqueEditorialeToElib({
                                                            marqueId: x.marqueId,
                                                            collectionId: x.collectionId,
                                                            elibId: selectedElib!!.id
                                                        }))}/>
                                        </label>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>


                </Grid>
                }

            </Grid>
        </>
    )
}

